document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.textContent = open ? 'Menu' : 'Close';
      menu.classList.toggle('is-open', !open);
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      const variants = JSON.parse(form.querySelector('[data-variants]').textContent);
      const selected = [...form.querySelectorAll('[data-option]')].map((input) => input.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      const id = form.querySelector('[name=id]');
      const button = form.querySelector('[type=submit]');
      if (variant) {
        id.value = variant.id;
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.addText : button.dataset.soldText;
        history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
      }
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const triggers = gallery.querySelectorAll('[data-gallery-trigger]');
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const id = trigger.dataset.galleryTrigger;
        slides.forEach((slide) => { slide.hidden = slide.dataset.mediaId !== id; });
        triggers.forEach((item) => {
          const selected = item === trigger;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
      });
    });
  });

  const paletteToggle = document.querySelector('[data-palette-toggle]');
  if (paletteToggle) {
    const key = 'forgetful-bandits-palette';
    const applyPalette = (mode) => {
      document.body.classList.toggle('palette-light', mode === 'light');
      document.body.classList.toggle('palette-dark', mode !== 'light');
      paletteToggle.setAttribute('aria-pressed', String(mode === 'light'));
      paletteToggle.setAttribute('aria-label', mode === 'light' ? 'Switch to dark mode' : 'Switch to light mode');
    };
    const savedMode = localStorage.getItem(key);
    applyPalette(savedMode || (document.body.classList.contains('palette-light') ? 'light' : 'dark'));
    paletteToggle.addEventListener('click', () => {
      const nextMode = document.body.classList.contains('palette-light') ? 'dark' : 'light';
      localStorage.setItem(key, nextMode);
      applyPalette(nextMode);
    });
  }
});
